const ACTION = {
  CHANGE_LANGUAGE: "CHANGE_LANGUAGE",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGOUT: "LOGOUT",
  UPDATE_TIME_PHQ9: "UPDATE_TIME_PHQ9",
  UPDATE_INFO: "UPDATE_INFORMATION"
};
export default ACTION;
